import { useMemo } from "react";
import { useSelector } from "react-redux";

import { dispatch } from "../../../../state/store";
import {
  setIsFileUploadDeclined,
  setIsMissingKeysModalActive,
  setIsMissingKeysModalLocalizationUploaded,
  setMissingKeysModalData,
  setMissingKeysModalLocalization
} from "../../../../state/ducks";

import { t } from "../../../../services";
import { strCode } from "../../../../consts";
import { objectUtil } from "../../../../utils";

import { Heading6, Modal, WrapperContainer } from "../../../../components";
import WarningMsg from "./WarningMsg";
import MissingKeysModalTable from "./MissingKeysModalTable";
import ControlButtons from "./ControlButtons";

const MissingKeysModal = () => {
  const isMissingKeysModalActive = useSelector((store) => store.apps.isMissingKeysModalActive);
  const missingKeysModalData = useSelector((store) => store.apps.missingKeysModalData);
  const localizationKeys = useSelector((store) => store.apps.selectedApp.localizationKeys);
  const isMissingKeysModalLocalizationUploaded = useSelector(
    (store) => store.apps.isMissingKeysModalLocalizationUploaded
  );

  const missingKeys = useMemo(() => {
    if (!missingKeysModalData || objectUtil.isEmpty(localizationKeys)) {
      return [];
    }

    return missingKeysModalData.reduce((accum, curr) => {
      return [
        ...accum,
        {
          missingKey: curr,
          defaultLocalization: localizationKeys[curr]
        }
      ];
    }, []);
  }, [missingKeysModalData, localizationKeys]);

  const onCancel = () => {
    if (isMissingKeysModalLocalizationUploaded) {
      dispatch(setIsMissingKeysModalLocalizationUploaded(false));
    }

    dispatch(setMissingKeysModalData(null));
    dispatch(setMissingKeysModalLocalization(null));
    dispatch(setIsMissingKeysModalActive(false));
    dispatch(setIsFileUploadDeclined(true));
  };

  const onContinue = () => {
    dispatch(setMissingKeysModalData(null));
    dispatch(setIsMissingKeysModalActive(false));
  };

  return (
    <Modal
      id="localization-missing-keys-modal"
      active={isMissingKeysModalActive}
      setActive={onCancel}
      modalHeader={<Heading6>{t(strCode.UPLOADING_SUMMARY)}</Heading6>}>
      <WrapperContainer>
        <WarningMsg missingKeysCount={missingKeysModalData?.length || 0} />
        <MissingKeysModalTable missingKeys={missingKeys} />

        <ControlButtons
          onCancel={onCancel}
          onContinue={onContinue}
          isMissingKeysModalLocalizationUploaded={isMissingKeysModalLocalizationUploaded}
        />
      </WrapperContainer>
    </Modal>
  );
};

export default MissingKeysModal;
